import {Promise} from 'es6-promise';

require('es6-promise').polyfill();

const rejectError = (res) => {
  if (res.status < 200 || res.status >= 300) {
    return res.json()
      .then((apiError) => {
        const err = new Error(apiError.message);
        err.url = res.url;
        err.statusCode = res.status;
        return Promise.reject(err);
      }, () => {
        const err = new Error(res.statusText);
        err.url = res.url;
        err.statusCode = res.status;
        return Promise.reject(err);
      });
  }
  return res;
};

const setupHeaders = (defaultHeaders = {}) => {
  const headers = Object.assign(defaultHeaders, {
    accept: 'application/json',
    'content-type': 'application/json',
  });
  return headers;
};

export default ({fetch, svcQaApi, isServerSide, headers}) => ({
  getQuestions: (order = 'latest', tag = '', context = 'general', offset = 0, limit = 20, contextual = '', showUnanswered) => {
    const showUnansweredFilter = showUnanswered ? `&showUnanswered=${showUnanswered}` : '';
    const questionUrl = `${svcQaApi}/questions/${order}?tag=${tag}&context=${context}&offset=${offset}&limit=${limit}&contextual=${contextual}${showUnansweredFilter}`; // eslint-disable-line max-len
    return fetch(questionUrl, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json());
  },
  getRelatedQuestions: (url, order = 'latest', context = 'general', offset = 0, limit = 20) =>
    fetch(`${svcQaApi}/questions/related-to/${url}?order=${order}&context=${context}&offset=${offset}&limit=${limit}`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  getQuestion: (url, contextType) => {
    const contextTypeFilter = contextType ? `?contextType=${contextType}` : '';
    return fetch(`${svcQaApi}/question/${url}${contextTypeFilter}`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
    .then(rejectError)
    .then((res) => res.json());
  },
  getQuestionForContext: (context) =>
    fetch(`${svcQaApi}/question/for-context/${context}`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
    .then(rejectError)
    .then((res) => res.json()),
  getUser: () =>
    fetch(`${svcQaApi}/user`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  getQuestionVotes: (id) => {
    if (isServerSide) { return {result: {notLoaded: true, question: {}, answers: []}}; }
    return fetch(`${svcQaApi}/question/${id}/votes`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json());
  },
  createQuestion: (question) =>
    fetch(`${svcQaApi}/question`, {
      method: 'POST',
      body: JSON.stringify(question),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  updateQuestion: (question) =>
    fetch(`${svcQaApi}/question/${question.id}`, {
      method: 'POST',
      body: JSON.stringify(question),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  deleteQuestion: (question) =>
    fetch(`${svcQaApi}/question/${question.id}/delete`, {
      method: 'POST',
      body: JSON.stringify(question),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  moderateQuestion: (question) =>
    fetch(`${svcQaApi}/question/${question.id}/moderate`, {
      method: 'POST',
      body: JSON.stringify(question),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  lockQuestion: (question) =>
    fetch(`${svcQaApi}/question/${question.id}/lock`, {
      method: 'POST',
      body: JSON.stringify(question),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  createAnswer: (answer) =>
    fetch(`${svcQaApi}/answer`, {
      method: 'POST',
      body: JSON.stringify(answer),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  updateAnswer: (answer) =>
    fetch(`${svcQaApi}/answer/${answer.id}`, {
      method: 'POST',
      body: JSON.stringify(answer),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  incrementQuestionCounter: (increment, type) =>
    fetch(`${svcQaApi}/question/${increment.question_id}/increment-${type}`, {
      method: 'POST',
      body: JSON.stringify(increment),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  incrementAnswerCounter: (increment) =>
    fetch(`${svcQaApi}/answer/${increment.answer_id}/increment`, {
      method: 'POST',
      body: JSON.stringify(increment),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  acceptAnswer: (answer, accept) =>
    fetch(`${svcQaApi}/answer/${answer.id}/accept`, {
      method: 'POST',
      body: JSON.stringify({answer_id: answer.answer_id, question_id: answer.question_id, accepted_answer: accept}),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  moderateAnswer: (answer) =>
    fetch(`${svcQaApi}/answer/${answer.id}/moderate`, {
      method: 'POST',
      body: JSON.stringify(answer),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  createComment: (comment) =>
    fetch(`${svcQaApi}/question-comment`, {
      method: 'POST',
      body: JSON.stringify(comment),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  updateComment: (comment) =>
    fetch(`${svcQaApi}/question-comment/${comment.id}`, {
      method: 'POST',
      body: JSON.stringify(comment),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  moderateComment: (comment) =>
    fetch(`${svcQaApi}/question-comment/${comment.id}/moderate`, {
      method: 'POST',
      body: JSON.stringify(comment),
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
  search: (q = '', contextType, offset = 0, limit = 20, type, tag = '', order = 'relevance') =>
    fetch(`${svcQaApi}/search?q=${q}&limit=${limit}&offset=${offset}&order=${order}&context_type=${contextType}`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
    .then(rejectError)
    .then((res) => res.json()),
  getTags: (contextType = 'general', onlyBaseTags) => {
    const tagsUrl = `${svcQaApi}/tags/for-context-type/${contextType}?onlyBaseTags=${onlyBaseTags}`;
    return fetch(tagsUrl, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
    .then(rejectError)
    .then((res) => res.json());
  },
  getMostPopularTags: (contextType = 'general') =>
    fetch(`${svcQaApi}/tags/most-popular-topics/${contextType}`, {
      credentials: 'same-origin',
      headers: setupHeaders(headers),
    })
      .then(rejectError)
      .then((res) => res.json()),
});
